import txBase, {TO_SAVE_BASE, KEY, initState as baseState} from '../../../vuex/tx-base';
import {registerModule} from '../../../vuex/helpers/vuex-pathify-register-module';
import {sync, make} from 'vuex-pathify'

import defaultMainText from '../data/mainText'
import deepmerge from "deepmerge";
import templateResetMutation from "../../../vuex/helpers/template-reset-mutation";

console.log(defaultMainText)
const STORE_NAMESPACE = 'poster-text';

function isSet(obj, key) {
    return obj && obj[key] !== typeof undefined
}

let mapData = window[KEY];

export const initState = (mapData) => {
    let mainText = isSet(mapData, 'mainText') ? mapData.mainText : defaultMainText;
    let authorText = isSet(mapData, 'authorText') ? mapData.authorText : '- Namn på den som sa det';

    return {
        textStyle: mapData?.textStyle || 'style-1',
        mainText,
        authorText,
    }
}

let vuexModule = {};
vuexModule.state = initState(mapData);

vuexModule.mutations = {
    ...make.mutations(vuexModule.state),
    reset: templateResetMutation(initState, STORE_NAMESPACE)
}

const EXCLUDE_FROM_SAVE = [];

let SAVE_PARAMS = [
    ...TO_SAVE_BASE,
    ...Object.keys(vuexModule.state).filter(item => !!EXCLUDE_FROM_SAVE.findIndex(exclude => item === exclude))
]

let extendedModule = deepmerge(txBase, vuexModule);

function members() {
    const {state} = extendedModule;
    let computed = {};
    for (let [key, value] of Object.entries(state)) {
        computed[key] = sync(`${STORE_NAMESPACE}/${key}`)
    }

    computed.toSaveParams = function () {
        let toSaveParams = {};
        for (let key of SAVE_PARAMS) {
            toSaveParams[key] = this[key]
        }
        return toSaveParams
    };

    return {
        computed,
    }
}


export default PosterTextModule => {
    return registerModule(STORE_NAMESPACE, extendedModule, members);
}